import { useMutation, useQueryClient } from "@tanstack/react-query";
import { removeConnectedAdvisorAndInvalidate } from "web_myplann/Api/Advisor/removeConnectedAdvisorAndInvalidate";
import {
	type AgentAssignedListItemResponseDTO,
	type DeleteAgentIdConnectionV2FetchResponse,
	deleteAgentIdConnectionV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useAdvisorDeleteMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse<
			AgentAssignedListItemResponseDTO,
			DeleteAgentIdConnectionV2FetchResponse
		>(({ id }) => deleteAgentIdConnectionV2(id)),
		onSuccess: (_response, advisor) =>
			removeConnectedAdvisorAndInvalidate(queryClient, advisor),
	});
};
